import { styled } from '@mui/material'
import Antelope from 'assets/branding/antelope.svg'

export const AntelopeLogo = styled(Antelope)({ width: 82 })
